import { render, staticRenderFns } from "./generalSituation.vue?vue&type=template&id=189747df&scoped=true"
import script from "./generalSituation.vue?vue&type=script&lang=js"
export * from "./generalSituation.vue?vue&type=script&lang=js"
import style0 from "./generalSituation.vue?vue&type=style&index=0&id=189747df&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "189747df",
  null
  
)

export default component.exports